export default __webpack_public_path__ + "assets/signIn.59f22f5f.png";